// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.AGWaterTrueQIForecast {
  color: #fff;
  background-color: #050e25;
  height: 90vh;
  width: 100%;
  margin: 0px;
  padding: 0px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px; }
  .AGWaterTrueQIForecast .expand-container {
    position: absolute;
    top: 65px;
    left: 90px;
    height: 83vh !important;
    width: 91%;
    z-index: 100; }
  .AGWaterTrueQIForecast .mapboxgl-popup-content {
    padding: 0px;
    min-width: 320px;
    opacity: 0.95;
    border-radius: 4px;
    width: 100% !important;
    background-color: #18244c; }
  .AGWaterTrueQIForecast .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: #18244c;
    opacity: 0.8; }
  .AGWaterTrueQIForecast .mapboxgl-popup-close-button {
    display: none; }
  .AGWaterTrueQIForecast .popup-container {
    opacity: 0.95;
    text-align: center;
    height: 100px;
    padding-top: 10px;
    padding-bottom: 32px;
    padding-left: 8px;
    padding-right: 8px;
    font-size: 14px;
    min-width: 320px;
    max-width: 320px;
    line-height: 10px;
    font-family: "Urbanist";
    display: flex;
    flex-direction: column;
    width: max-content; }
  .AGWaterTrueQIForecast .popup-container h4 {
    line-height: 24px;
    min-height: 50px;
    color: #4fc2d9; }
  .AGWaterTrueQIForecast .popup-content {
    display: flex;
    flex-direction: row;
    justify-content: flex-start; }
  .AGWaterTrueQIForecast .popup-content-left {
    text-align: right;
    margin-right: 10px;
    min-width: 150px;
    overflow: hidden;
    line-height: 20px; }
  .AGWaterTrueQIForecast .popup-content-right {
    padding-top: 5px;
    text-align: left;
    width: 190px;
    font-size: 21px; }
  .AGWaterTrueQIForecast .container {
    display: flex;
    padding: 0;
    height: calc(100% - 80px);
    margin-top: 10px;
    max-width: unset;
    width: calc(100% - 80px); }
    .AGWaterTrueQIForecast .container input,
    .AGWaterTrueQIForecast .container select {
      margin-bottom: 50px; }
    .AGWaterTrueQIForecast .container .main-col {
      max-width: -webkit-fill-available; }
    .AGWaterTrueQIForecast .container .map-title {
      width: auto;
      white-space: nowrap;
      position: absolute;
      left: 59px;
      top: 0px;
      font-size: 1.25rem;
      padding: 5px;
      z-index: 9; }
    .AGWaterTrueQIForecast .container .map-best-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      position: relative;
      height: 45vh;
      padding: 0px !important; }
    .AGWaterTrueQIForecast .container .map-legend {
      width: 159px;
      position: absolute;
      border-radius: 5px;
      padding: 5px;
      right: 42px;
      bottom: 10px;
      background-color: #18244c;
      z-index: 90; }
    .AGWaterTrueQIForecast .container .map-legend p {
      margin-left: 5px;
      height: 30px; }
    .AGWaterTrueQIForecast .container .map-legend span {
      width: 100px;
      margin-left: 5px; }
    .AGWaterTrueQIForecast .container .map-legend-dot {
      background-color: #4b5ea6;
      height: 14px;
      width: 14px;
      margin-left: 5px;
      margin-right: 5px;
      border-radius: 50%;
      display: inline-flex; }
    .AGWaterTrueQIForecast .container .attribution-textbox {
      font-size: 0.6rem;
      position: absolute;
      right: 1px;
      bottom: 0px;
      width: auto; }
    .AGWaterTrueQIForecast .container .attribution-container {
      text-align: end; }
    .AGWaterTrueQIForecast .container .attribution-container-textRun {
      font-size: 14pt;
      color: #4fc32c; }
    .AGWaterTrueQIForecast .container .attribution-container-textRun-source {
      font-size: 14pt;
      color: #0b61bf; }
    .AGWaterTrueQIForecast .container .chart-container {
      background-color: #0b1736;
      border-radius: 2px;
      box-shadow: 0px 0px 20px #000;
      display: flex;
      margin-top: 20px;
      height: 32vh;
      position: relative; }
    .AGWaterTrueQIForecast .container .chart-line-container {
      height: 100%;
      width: 100%;
      width: -webkit-fill-available;
      width: -moz-available;
      width: stretch; }
    .AGWaterTrueQIForecast .container .report-options {
      margin-top: 10px;
      text-align: right;
      margin-right: 10px;
      position: absolute;
      right: 1%;
      top: 1%; }
      .AGWaterTrueQIForecast .container .report-options button {
        background-color: #fff;
        border: unset;
        margin-left: 10px; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .AGWaterTrueQIForecast .header-container h2 {
    font-size: 25px; } }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/features/reports/AGWaterTrueQIForecast/styles.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACdrD;EACE,WDVqB;ECWrB,yBDEsC;ECDtC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EAEZ,kBAfoB;EAgBpB,mBAhBoB;EAiBpB,iBAhBmB,EAAA;EAMrB;IAaI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,UAAU;IACV,YAAY,EAAA;EAlBhB;IAsBI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB,EAAA;EA3B7B;IA+BI,4BAA4B;IAC5B,YAAY,EAAA;EAhChB;IAoCI,aAAa,EAAA;EApCjB;IAwCI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB,EAAA;EAtDtB;IA0DI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAA;EA5DlB;IAgEI,aAAa;IACb,mBAAmB;IACnB,2BAA2B,EAAA;EAlE/B;IAsEI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB,EAAA;EA1ErB;IA8EI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,eAAe,EAAA;EAjFnB;IAqFI,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB,EAAA;IA1F5B;;MA8FM,mBAAmB,EAAA;IA9FzB;MAkGM,iCAAiC,EAAA;IAlGvC;MAsGM,WAAW;MACX,mBAAmB;MACnB,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,kBAAkB;MAClB,YAAY;MACZ,UAAU,EAAA;IA7GhB;MAiHM,yBDvH0B;MCwH1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,uBAAuB,EAAA;IAvH7B;MA2HM,YAAY;MACZ,kBAAkB;MAClB,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,yBAAyB;MACzB,WAAW,EAAA;IAlIjB;MAsIM,gBAAgB;MAChB,YAAY,EAAA;IAvIlB;MA2IM,YAAY;MACZ,gBAAgB,EAAA;IA5ItB;MAgJM,yBAAyB;MACzB,YAAY;MACZ,WAAW;MACX,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,oBAAoB,EAAA;IAtJ1B;MA0JM,iBAAiB;MACjB,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,WAAW,EAAA;IA9JjB;MAkKM,eAAe,EAAA;IAlKrB;MAsKM,eAAe;MACf,cAAuB,EAAA;IAvK7B;MA2KM,eAAe;MACf,cAAuB,EAAA;IA5K7B;MAgLM,yBDtL0B;MCuL1B,kBAAkB;MAClB,6BAA6B;MAC7B,aAAa;MACb,gBAAgB;MAChB,YAAY;MACZ,kBAAkB,EAAA;IAtLxB;MA0LM,YAAY;MACZ,WAAW;MAEX,6BAA6B;MAC7B,qBAAc;MAAd,cAAc,EAAA;IA9LpB;MAkMM,gBAAgB;MAChB,iBAAiB;MACjB,kBAAkB;MAClB,kBAAkB;MAClB,SAAS;MACT,OAAO,EAAA;MAvMb;QA0MQ,sBAAsB;QACtB,aAAa;QACb,iBAAiB,EAAA;;AAOzB;EACE;IAES,eAAe,EAAA,EAAG","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../../../theme/_variables.scss\";\n\n$paddingLeftSize: 10px;\n$paddingTopSize: 10px;\n$tableDividerLineColor: #222224;\n$tableDividerLineBorderSize: 0.5px;\n$tableFontSize: 1.2vw;\n$positionTop: 140px;\n\n.AGWaterTrueQIForecast {\n  color: $primaryFontColor;\n  background-color: $containerScreenBackgroundColor;\n  height: 90vh;\n  width: 100%;\n  margin: 0px;\n  padding: 0px;\n\n  padding-left: $paddingLeftSize;\n  padding-right: $paddingLeftSize;\n  padding-top: $paddingTopSize;\n\n  .expand-container {\n    position: absolute;\n    top: 65px;\n    left: 90px;\n    height: 83vh !important;\n    width: 91%;\n    z-index: 100;\n  }\n\n  .mapboxgl-popup-content {\n    padding: 0px;\n    min-width: 320px;\n    opacity: 0.95;\n    border-radius: 4px;\n    width: 100% !important;\n    background-color: #18244c;\n  }\n\n  .mapboxgl-popup-anchor-top .mapboxgl-popup-tip {\n    border-bottom-color: #18244c;\n    opacity: 0.8;\n  }\n\n  .mapboxgl-popup-close-button {\n    display: none;\n  }\n\n  .popup-container {\n    opacity: 0.95;\n    text-align: center;\n    height: 100px;\n    padding-top: 10px;\n    padding-bottom: 32px;\n    padding-left: 8px;\n    padding-right: 8px;\n    font-size: 14px;\n    min-width: 320px;\n    max-width: 320px;\n    line-height: 10px;\n    font-family: \"Urbanist\";\n    display: flex;\n    flex-direction: column;\n    width: max-content;\n  }\n\n  .popup-container h4 {\n    line-height: 24px;\n    min-height: 50px;\n    color: #4fc2d9;\n  }\n\n  .popup-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n\n  .popup-content-left {\n    text-align: right;\n    margin-right: 10px;\n    min-width: 150px;\n    overflow: hidden;\n    line-height: 20px;\n  }\n\n  .popup-content-right {\n    padding-top: 5px;\n    text-align: left;\n    width: 190px;\n    font-size: 21px;\n  }\n\n  .container {\n    display: flex;\n    padding: 0;\n    height: calc(100% - 80px);\n    margin-top: 10px;\n    max-width: unset;\n    width: calc(100% - 80px);\n\n    input,\n    select {\n      margin-bottom: 50px;\n    }\n\n    .main-col {\n      max-width: -webkit-fill-available;\n    }\n\n    .map-title {\n      width: auto;\n      white-space: nowrap;\n      position: absolute;\n      left: 59px;\n      top: 0px;\n      font-size: 1.25rem;\n      padding: 5px;\n      z-index: 9;\n    }\n\n    .map-best-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      position: relative;\n      height: 45vh;\n      padding: 0px !important;\n    }\n\n    .map-legend {\n      width: 159px;\n      position: absolute;\n      border-radius: 5px;\n      padding: 5px;\n      right: 42px;\n      bottom: 10px;\n      background-color: #18244c;\n      z-index: 90;\n    }\n\n    .map-legend p {\n      margin-left: 5px;\n      height: 30px;\n    }\n\n    .map-legend span {\n      width: 100px;\n      margin-left: 5px;\n    }\n\n    .map-legend-dot {\n      background-color: #4b5ea6;\n      height: 14px;\n      width: 14px;\n      margin-left: 5px;\n      margin-right: 5px;\n      border-radius: 50%;\n      display: inline-flex;\n    }\n\n    .attribution-textbox {\n      font-size: 0.6rem;\n      position: absolute;\n      right: 1px;\n      bottom: 0px;\n      width: auto;\n    }\n\n    .attribution-container {\n      text-align: end;\n    }\n\n    .attribution-container-textRun {\n      font-size: 14pt;\n      color: rgb(79, 195, 44);\n    }\n\n    .attribution-container-textRun-source {\n      font-size: 14pt;\n      color: rgb(11, 97, 191);\n    }\n\n    .chart-container {\n      background-color: $topMenuBackgroundColor;\n      border-radius: 2px;\n      box-shadow: 0px 0px 20px #000;\n      display: flex;\n      margin-top: 20px;\n      height: 32vh;\n      position: relative;\n    }\n\n    .chart-line-container {\n      height: 100%;\n      width: 100%;\n      width: -moz-available;\n      width: -webkit-fill-available;\n      width: stretch;\n    }\n\n    .report-options {\n      margin-top: 10px;\n      text-align: right;\n      margin-right: 10px;\n      position: absolute;\n      right: 1%;\n      top: 1%;\n\n      button {\n        background-color: #fff;\n        border: unset;\n        margin-left: 10px;\n      }\n    }\n  }\n}\n\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {\n  .AGWaterTrueQIForecast {\n    .header-container {\n      h2 { font-size: 25px;}\n    }\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
